	export enum DispensingPlanModeEnum {
		Attribute = 1,
		Price = 2
	}
